import { createFileRoute, redirect } from '@tanstack/react-router'

/** `/platform` on its own opens the Overview. */
export const Route = createFileRoute('/_app/platform/')({
  beforeLoad: () => {
    throw redirect({ to: '/platform/overview', replace: true })
  },
})
